import { render, staticRenderFns } from "./UILanguageSwitcher.vue?vue&type=template&id=394efd64&scoped=true&"
import script from "./UILanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./UILanguageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./UILanguageSwitcher.vue?vue&type=style&index=0&id=394efd64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394efd64",
  null
  
)

export default component.exports